var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { plainToInstance } from 'class-transformer';
import queries from 'constants/queries';
import { PaginationMetaData, Stock } from 'models';
import { useQuery } from 'react-query';
import ApiService from '../ApiService';
import StockAudit from 'models/entities/inventory/StockAudit';
var StockService = /** @class */ (function (_super) {
    __extends(StockService, _super);
    function StockService() {
        var _this = _super.call(this) || this;
        _this.stocksRoot = 'stocks';
        return _this;
    }
    StockService.prototype.useStocks = function (pageNumber, filters) {
        var _this = this;
        if (pageNumber === void 0) { pageNumber = 1; }
        if (filters === void 0) { filters = {}; }
        return useQuery([queries.inventory.stocks, pageNumber, filters], function () {
            return _this.get(_this.stocksRoot, __assign(__assign({}, filters), { page: pageNumber }));
        }, {
            keepPreviousData: true,
            select: function (_a) {
                var data = _a.data;
                var stocks = plainToInstance(Stock, data === null || data === void 0 ? void 0 : data.stocks);
                var meta = plainToInstance(PaginationMetaData, data === null || data === void 0 ? void 0 : data.meta);
                return { stocks: stocks, meta: meta };
            }
        });
    };
    StockService.prototype.useStockAudit = function (locationId, fetchEnabled) {
        var _this = this;
        if (fetchEnabled === void 0) { fetchEnabled = true; }
        return useQuery([queries.inventory.stockAudit, locationId], function () {
            return _this.get("".concat(_this.stocksRoot, "/stock_audit"), {
                location_id: locationId
            });
        }, {
            enabled: fetchEnabled,
            staleTime: 0,
            cacheTime: 0,
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(StockAudit, data);
            }
        });
    };
    StockService.prototype.fetchStockAudit = function (queryClient, locationId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.fetchQuery([queries.inventory.stockAudit, locationId], function () {
                            return _this.get("".concat(_this.stocksRoot, "/stock_audit"), { location_id: locationId }).then(function (res) { return plainToInstance(StockAudit, res.data); });
                        }, {
                            staleTime: 0,
                            cacheTime: 0,
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    StockService.prototype.useStock = function (id) {
        var _this = this;
        return useQuery(['show', queries.inventory.stocks, id], function () {
            return _this.get("".concat(_this.stocksRoot, "/").concat(id));
        }, {
            select: function (_a) {
                var data = _a.data;
                return plainToInstance(Stock, data);
            }
        });
    };
    StockService.getInstance = function () {
        if (!StockService.stockService) {
            StockService.stockService = new StockService();
        }
        return StockService.stockService;
    };
    return StockService;
}(ApiService));
export default StockService;
